import React from 'react'
// ##
import SuperadminsTable from '../../modules/Superadmin/components/SuperadminsTable'

export default function SuperadminPage() {
  return <SuperadminsTable />
}
